export const SET_SITE_ATTRIBUTES = 'SET_SITE_ATTRIBUTES';

export interface IAttributesState {
  isEuUser: boolean;
  captcha: Captcha | null;
  isJoinCaptchaEnabled: boolean;
  isLoginCaptchaEnabled: boolean;
  cf_country: string;
}

interface SetSiteAttributesAction {
  type: typeof SET_SITE_ATTRIBUTES;
  payload: IAttributesState;
}

export interface Captcha {
  captcha_key: string;
  source: string;
}

export type AttributesActionType = SetSiteAttributesAction;
